var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrganicSectionShape = function SvgOrganicSectionShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2318 1418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1245.66 322.115c-207.8-167.41-751.811-375.172-940.902-306.712-189.091 68.461-355.431 495.577 0 1067.317 355.431 571.75 1464.192 244.74 1813.052 23.74 348.86-221.003 173.22-572.096-39.44-604.576-212.65-32.48-624.9-12.359-832.71-179.769Z",
    stroke: "#CDAA96",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.89 372.177C1004.96 204.735 460.622-3.068 271.416 65.406c-189.205 68.474-502.141 546.507 0 1067.524 502.141 521.03 1586.134 202.79 1814.154 23.74 228.01-179.036 173.32-572.203-39.47-604.689-212.78-32.486-625.28-12.362-833.21-179.804Z"
  })));
};
export default SvgOrganicSectionShape;